module.exports = function ($, M, soundManager) {
  'use strict';

  var AudioPlayer = function () {
    this.playing = false;
    this.currentUrl = null;

    this.play = function (options) {
      var self = this,
        url = options.url || null;

      if (url === null) {
        return false;
      }

      if (this.setMute()) {
        return;
      }

      var sound = this.loadSound(url);
      if (!sound) {
        return;
      }

      this.stop();

      this.triggerSound({
        sound: sound,
        onplay: function () {
          self.playing = true;
          self.currentUrl = url;
          if (options.onplay !== null) {
            options.onplay(url);
          }
        },
        onfinish: function () {
          self.playing = false;
          if (options.onfinish !== null) {
            options.onfinish(url);
          }
          if (self.whenFinishedCallback) {
            self.whenFinishedCallback();
            delete self.whenFinishedCallback;
          }
        },
      });
    };

    this.setMute = function () {
      var muted = $('body').hasClass('audio-muted');
      if (muted) {
        soundManager.mute();
        return true;
      } else {
        soundManager.unmute();
        return false;
      }
    };

    this.loadSound = function (url) {
      var sound;
      if (
        soundManager &&
        soundManager.ok() &&
        soundManager.canPlayURL(url)
      ) {
        this.currentUrl = url;
        // returns a sound from cache if ID exists
        sound = soundManager.createSound({
          id: url,
          url: url,
        });
      }
      return sound;
    };

    this.triggerSound = function (options) {
      options.sound.play({
        onplay: options.onplay,
        onfinish: options.onfinish,
        onstop: options.onfinish,
      });
    };

    this.stop = function () {
      soundManager.stopAll();
      this.playing = false;
      this.currentUrl = null;
      // Cancel timeout
      $.doTimeout('AudioPlayer-stopAfter');
    };

    this.stopAfter = function (milliseconds) {
      var self = this;
      if (this.playing) {
        $.doTimeout('AudioPlayer-stopAfter', milliseconds, function () {
          self.stop();
        });
      }
    };

    this.whenFinished = function (callback) {
      // Whilst you can pass an onfinish to play(), we also accept a
      // callback after-the-fact
      if (!this.playing) {
        callback();
      } else {
        this.whenFinishedCallback = callback;
      }
    };
  };

  M.audioPlayer = new AudioPlayer();

  // Audio player handling.
  $(document)
    .on('memrise.audio-play', 'a.audio-player', function () {
      var $this = $(this);
      M.audioPlayer.play({
        url: $this.attr('href'),
        onplay: function () {
          $this.addClass('playing');
        },
        onfinish: function () {
          $this.removeClass('playing');
        },
      });
    })
    .on('memrise.audio-stop', 'a.audio-player', function () {
      M.audioPlayer.stop();
    })
    .on('mouseenter', 'a.audio-player.audio-player-hover', function (e) {
      if (!MEMRISE.is_iOS_optimised) {
        $(this).trigger('memrise.audio-play');
      }
      e.preventDefault();
    })
    .on('click', 'a.audio-player.audio-player-hover', function (e) {
      // iOS 5+ does not trigger mouseenter for events, and thus we transform
      // our hover audio players back into click ones
      if (MEMRISE.is_iOS_optimised) {
        $(this).trigger('memrise.audio-play');
      }
      e.preventDefault();
    });
};
